module.exports = __webpack_public_path__ + "static/media/SMEB_colour.19906cd1.svg";